module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-decoration-arrow-00b05e6015bb2614580cd18ae477fd5a.png";